import React, { ComponentProps } from 'react';
import Slider from 'react-slick';

import classnames from 'classnames/bind';
import styles from './imgSlide.module.scss';
const cx = classnames.bind(styles);

const ImgSlide = ({ children }: ComponentProps<any>) => {
  const settings = {
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 700,
    cssEase: 'ease-in-out',
    draggable: true,
    pauseOnHover: true,
  };

  return (
    <Slider {...settings} className={cx('slider')}>
      {children}
    </Slider>
  );
};

export default ImgSlide;
